import { connect } from 'react-redux'

import { showTransientNotification } from '@driftt/traffic-control'
import ContactsList from 'components/Contacts'
import {
  deselectContact,
  receiveContacts,
  selectContact
} from 'modules/contacts/actions'

const mapStateToProps = state => {
  return {
    orgId: state.user.orgId,
    contacts: state.__CRM.contacts.contacts,
    selectedContacts: state.__CRM.contacts.selectedContacts
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onReceiveContacts: contacts => {
      dispatch(receiveContacts(contacts))
    },
    onSelectContact: contactId => {
      dispatch(selectContact(contactId))
    },
    onDeselectContact: contactId => {
      dispatch(deselectContact(contactId))
    },
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactsList)
